import { Div } from "@max/common-ui";
import React from "react";
import styled from "styled-components";

const Wrapper = styled(Div)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Bounce = styled(Div)`
  width: ${(props) => props.size || "12px"};
  height: ${(props) => props.size || "12px"};
  margin: 0 5px 0 5px;
  background-color: ${(props) =>
    props.color ? props.color : props.theme.gray30};
  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }
  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
`;

const Bounce1 = styled(Bounce)`
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
`;

const Bounce2 = styled(Bounce)`
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
`;

const SpinnerContainer = styled(Div)`
  width: 70px;
  text-align: center;
`;

const Spinner = ({ color = "#A6AEB2", size = "12px" }) => {
  return (
    <Wrapper>
      <SpinnerContainer>
        <Bounce1 color={color} size={size} />
        <Bounce2 color={color} size={size} />
        <Bounce color={color} size={size} />
      </SpinnerContainer>
    </Wrapper>
  );
};

export default Spinner;
